export const DRAW_AREA_PREVIEW_SHOW = 'DRAW_AREA_PREVIEW_SHOW';
export const DRAW_AREA_PREVIEW_MOVE = 'DRAW_AREA_PREVIEW_MOVE';
export const DRAW_AREA_PREVIEW_HIDE = 'DRAW_AREA_PREVIEW_HIDE';
export const DRAW_AREA_SHAPE_PREVIEW_START = 'DRAW_AREA_SHAPE_PREVIEW_START';
export const DRAW_AREA_SHAPE_PREVIEW_MOVE = 'DRAW_AREA_SHAPE_PREVIEW_MOVE';
export const DRAW_AREA_SHAPE_PREVIEW_END = 'DRAW_AREA_SHAPE_PREVIEW_END';
